import {useSelector} from 'react-redux';
import Selector from '../../../../../selectors/modals/wallet/methods/paypal_deposit/index';

import {useEffect} from 'react';
import Triggers from '../../../../../lib/triggers';

import Create from './create';
import Confirm from './confirm';

export default () => {
    const {stage} = useSelector(Selector);

    useEffect(() => {
        Triggers.modal_open({
            modal: "wallet",
            tab: "deposit",
            method: "paypal"
        });
    }, [])

    if(stage === 'create') return <Create />
    if(stage === 'confirm') return <Confirm />
    return <>{stage}</>;
}